import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

export const useFDAEnvironment = () =>
  useAppSelector(organizationModel.selectors.selectFDAEnvironment);
